<div class="dimensions">
    <div class="navBarView d-flex justify-content-around align-items-center">
        <h4>Journal Buddy</h4>
    </div>
    <div class="bodyContent d-flex flex-column justify-content-top">
        <div class="height10">
            <div class="w-100  d-flex justify-content-center py-4">
                <img src="../../assets/back.png" class="ml-2 backSizing" alt="backIcon" (click)="goBack()">
                <input class="w-75" type="text" placeholder="Search..">
                <img src="../../assets/search.png" class="ml-2 searchSizing" alt="searchIcon">
            </div>
        </div>
        <div class="height70">
            <div class="w-100  d-flex justify-content-left py-4">
                <a routerLink="/25October"><img src="../../assets/mic.png" class="ml-2 micSizing" alt="micIcon"></a>
                <div class="d-flex align-items-center">25 October 2020</div>

            </div>
            <div class="w-100  d-flex justify-content-left py-4">
                <img src="../../assets/mic.png" class="ml-2 micSizing" alt="micIcon">
                    <div class="d-flex align-items-center">24 October 2020</div>

            </div>
            <div class="w-100  d-flex justify-content-left py-4">
                <img src="../../assets/mic.png" class="ml-2 micSizing" alt="micIcon">
                    <div class="d-flex align-items-center">1227 Exam - 24th October 2020</div>

            </div>
        </div>
    </div>
</div>